import consents from '@/services/api/consents'

import { ACTION_TYPES as APP_ACTION_TYPES } from '@/store/modules/app'

export const CONSENT_STATES = {
  PENDING: 'pending',
  REVOKED: 'revoked',
  GRANTED: 'granted'
}

export const MUTATION_TYPES = {
  SET_CONSENTS: 'SET_CONSENTS'
}

export const ACTION_TYPES = {
  GET_ALL_CONSENTS: 'GET_ALL_CONSENTS',
  GET_CONSENT: 'GET_CONSENT',
  ACCEPT_CONSENT: 'ACCEPT_CONSENT',
  GRANT_CONSENT: 'CONFIRM_CONSENT',
  REVOKE_CONSENT: 'REVOKE_CONSENT'
}

const state = {
  all: []
}

const getters = {
  allConsents: state => state.all
}

// TODO catch401 should be a generic?
const logoutOn401 = (response, dispatch, defaultData) => {
  if (dispatch && response && response.request && (response.request.status === 401 || response.request.status === 0)) {
    dispatch(APP_ACTION_TYPES.LOGOUT)
    window.location.reload()
  }
  return defaultData
}

const actions = {
  async [ACTION_TYPES.GET_ALL_CONSENTS]({ commit, dispatch }) {
    const items = await consents
      .getAll()
      .catch((res) => {
        logoutOn401(res, dispatch, [])
      })

    commit(MUTATION_TYPES.SET_CONSENTS, { consents: items })
    return items
  },

  async [ACTION_TYPES.GET_CONSENT]({ commit, dispatch }, id) {
    return await consents
      .getSingle(id)
      .catch(res => logoutOn401(res))
  },

  async [ACTION_TYPES.ACCEPT_CONSENT]({ commit, dispatch }, { id }) {
    return await consents.accept(id)
      .then(_ => true)
      .catch((res) => logoutOn401(res, dispatch, false))
  },

  async [ACTION_TYPES.GRANT_CONSENT]({ commit, dispatch }, { id, pin }) {
    return await consents.grant(id, pin).then(res => res.data).catch(_ => null)
  },

  async [ACTION_TYPES.REVOKE_CONSENT]({ commit, dispatch }, { id }) {
    return await consents.revoke(id).then(_ => true).catch(_ => false)
  }
}

const mutations = {
  [MUTATION_TYPES.SET_CONSENTS](state, { consents }) {
    state.all = consents
  }
}

export const consentsModule = {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/consents.js